import React, { Component } from 'react'
import { reduxForm, Field, formValueSelector, FormErrors } from 'redux-form'
import { connect } from 'react-redux'
import {
  selectCurrentRefiUser,
  selectCurrentRefiApplication,
} from '../../../reducers'
import { Address } from '../../../core/types'

import { allStateOptions } from '../../common/stateOptions'
import {
  InputField,
  RadiobuttonGroup,
  SelectField,
} from '../../../components/inputs'
import LoaderButton from '../../../components/loaderButton'
import { PHONE_MASK, PHONE_PLACEHOLDER } from '../../../utils/phoneMask'
import { ReduxFormProps } from '../../../forms'

export interface Props {
  generateEmail: boolean
  plate_state: string
}

export interface FormProps {
  id: string
  email: string
  email2: string
  firstName: string
  generateEmail: boolean
  lastName: string
  phone: string
  line1: string
  city: string
  state: string
  zip: string
  birthday: string
  ssn: string
  line2: string
}

const FORM_NAME = 'ProfileDetailForm'

export class CreateUserForm extends Component<
  ReduxFormProps<Props, FormProps>
> {
  render() {
    const { generateEmail, handleSubmit, submitting } = this.props

    return (
      <form className="form" name="CreateUserForm" onSubmit={handleSubmit}>
        <div
          className="refi-app__form"
          // disabled={submitting} // TODO-TS
        >
          <Field<any> // TODO-TS
            type="text"
            label="Legal first name"
            name="firstName"
            component={InputField}
            aria-required="true"
          />

          <Field<any> // TODO-TS
            type="text"
            label="Legal last name"
            name="lastName"
            component={InputField}
            aria-required="true"
          />

          <Field<any> // TODO-TS
            type="text"
            label="Address"
            name="line1"
            component={InputField}
            aria-required="true"
          />

          <Field
            type="text"
            label="Address line 2"
            name="line2"
            component={InputField}
          />

          <Field<any> // TODO-TS
            type="text"
            label="City"
            name="city"
            component={InputField}
            aria-required="true"
          />

          <div className="refi-app__form-group">
            <Field<any>
              label="State"
              name="state"
              component={SelectField}
              aria-required="true"
            >
              {allStateOptions}
            </Field>

            <Field<any> // TODO-TS
              type="text"
              label="Zip code"
              name="zip"
              component={InputField}
              mask={[/\d/, /\d/, /\d/, /\d/, /\d/]}
              aria-required="true"
            />
          </div>

          <Field<any> // TODO-TS
            type="text"
            label="Phone number"
            name="phone"
            component={InputField}
            placeholder={PHONE_PLACEHOLDER}
            mask={PHONE_MASK}
            startAdornment="+1"
            aria-required="true"
          />
        </div>

        <div>
          <div>
            <RadiobuttonGroup
              name="generateEmail"
              value={false}
              label="Use customer email"
              checked={!generateEmail}
            />
            <RadiobuttonGroup
              name="generateEmail"
              value={true}
              label="No email given"
              checked={generateEmail}
            />
          </div>

          {!generateEmail && (
            <div className="refi-app__form">
              <Field<any> // TODO-TS
                type="text"
                label="Email"
                name="email"
                component={InputField}
                aria-required="true"
              />

              <Field<any> // TODO-TS
                type="text"
                label="Re-enter email"
                name="email2"
                component={InputField}
                aria-required="true"
              />
            </div>
          )}
        </div>

        <div className="form__group refi-app__form-buttons">
          <LoaderButton
            type="submit"
            className="button button-drive-america filter__button--apply"
            isLoading={submitting}
          >
            Next
          </LoaderButton>
        </div>
      </form>
    )
  }
}

export const validate = (data: FormProps): FormErrors<FormProps> => {
  const {
    firstName,
    generateEmail,
    lastName,
    email,
    email2,
    phone,
    line1,
    city,
    state,
    zip,
  } = data
  const errors: FormErrors<FormProps> = {}

  if (!generateEmail) {
    if (!email) {
      errors.email = 'Email is required'
    }

    if (email && email !== email2) {
      errors.email2 = 'Does not match'
    }
  }

  if (!firstName) {
    errors.firstName = 'First name is required'
  }

  if (!lastName) {
    errors.lastName = 'Last name is required'
  }

  if (!phone) {
    errors.phone = 'Phone is required'
  }

  if (!line1) {
    errors.line1 = 'Address is required'
  }

  if (!city) {
    errors.city = 'City is required'
  }

  if (!state) {
    errors.state = 'State is required'
  }

  if (!zip) {
    errors.zip = 'Zip code is required'
  }

  return errors
}
const BaseCreateUserForm = reduxForm<FormProps, Props>({
  form: FORM_NAME,
  validate,
  enableReinitialize: true,
  destroyOnUnmount: false,
})(CreateUserForm)

const mapStateToProps = (state, ownProps: Props) => {
  const selector = formValueSelector(FORM_NAME)
  const generateEmail = selector(state, 'generateEmail') === true

  const user = selectCurrentRefiUser(state) || {}
  const app = selectCurrentRefiApplication(state) || {}

  // Get product package's address (or fallback to first address)
  let addr: Partial<Address> = {}
  if (user.addresses) {
    addr =
      user.addresses.find((a) => a.id === app.addressId) ||
      user.addresses[0] ||
      {}
  }

  const initialValues: Partial<FormProps> = {
    id: user.id,
    firstName: user.firstName || '',
    lastName: user.lastName || '',
    phone: user.phone || '',
    email: user.email || user.crmSyncMetadata?.unverified_email || '',
    email2: user.email || '',
    generateEmail:
      user.email || user.crmSyncMetadata?.unverified_email ? false : true,
    line1: addr.line1 || '',
    line2: addr.line2 || '',
    city: addr.city || '',
    state: addr.state || ownProps.plate_state,
    zip: addr.zip || '',
  }
  return { initialValues, generateEmail }
}

export default connect(mapStateToProps)(BaseCreateUserForm)
